export default "__VITE_ASSET__oHNJzRds__"